var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      staticClass: "vicon",
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "32",
        height: "32",
        fill: "currentColor",
        viewBox: "0 0 256 256",
      },
    },
    [
      _c("rect", { attrs: { width: "256", height: "256", fill: "none" } }),
      _c("polyline", {
        attrs: {
          points: "40 144 96 200 224 72",
          fill: "none",
          stroke: "currentColor",
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }